export default __webpack_public_path__ + "static/media/members.653d3b05.svg";